//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import DIC from '@/index/dictionary'


export default {
  components: {
    DialogDealer: () => import('../../../../components/DialogDealer/index.vue'),
  },
  props: {
    tab: {
      default: ''
    },
    tableData: {
      default: () => []
    },
    pageData: {
      default: () => ({})
    },
    searchData: {
      default: () => ({})
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      addDialogVisible: false,
      editDialogVisible: false,
      detailDialogVisible: false,
      dealerDialogVisible: false,
      DIC: DIC
    }
  },
  computed: {
    toQuery (){
      return {
        tab: this.tab,
        pageData: JSON.stringify(this.pageData),
        searchData: JSON.stringify(this.searchData)
      }
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleDelete: function (row) {
      if(row.state.submiting === false){
        row.state.submiting = true
        let data = {id: row.data.goodsId}
        // console.log('data', data)
        this.$axios.post('/mtea/store/admin/goods/del', data).then(res => {
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          this.$emit('submit')
        }).finally(() => {
          row.state.submiting = false
        })
      }
    },
    handlePublish (row) {
      if(row.state.submiting === false){
        row.state.submiting = true
        let url = '/mtea/store/admin/goods/publish'
        let data = _.pick(row.data, 'goodsId')
        this.$axios.post(url, data).then(res => {
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          this.$emit('submit')
        }, () => {

        }).finally(() => {
          row.state.submiting = false
        })
      }
    },
    handleUnPublish (row) {
      if (row.state.submiting===false) {
        let url = '/mtea/store/admin/goods/unpublish'
        let data = _.pick(row.data, 'goodsId')
        row.state.submiting = true
        this.$axios.post(url, data).then(res => {
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          this.$emit('submit')
        }).finally(() => {
          row.state.submiting = false
        })
      }
    }
  }
}
